import { render, staticRenderFns } from "./logging.banzaicloud.io.flow.vue?vue&type=template&id=8da85a8e&"
import script from "./logging.banzaicloud.io.flow.vue?vue&type=script&lang=js&"
export * from "./logging.banzaicloud.io.flow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports